export class RelationShip
{
    id:Number;
    parentobjectName:String;
    parentobjectId:Number;
    parentIdName:String;
    parentRowId:Number;
    childObjectName:String;
    childObjectId:Number;
    childIdName:String;
    childRowId:Number;
}